import React from 'react';
import {Box, Grid } from '@mui/material';
import styles from 'styles/informacionDelCard';
import TituloConIcono from 'components/tituloConIcono';
import ElementoDelCard from 'components/card/ElementoDelCard';

const Exterior = ({datosGeneralesDeSolicitud}) => {
  const classes = styles();
  const listadoExteriores = datosGeneralesDeSolicitud?.solicitudExteriores || [];

  const tipoExteriorDe = (item) => Number(item?.tipoExterior || item?.idTipoExterior || 0);

  const esVallaDigital = (item) => Boolean(item?.esVallaDigital || item?.espantalla || tipoExteriorDe(item) === 4);
  const esVallaFija = (item) => Boolean(item?.esVallaFija || item?.esvalla || tipoExteriorDe(item) === 5);
  const esVallaMovil = (item) => Boolean(item?.esVallaMovil || tipoExteriorDe(item) === 6);
  const esPaginaWeb = (item) => Boolean(item?.esPaginaWeb || tipoExteriorDe(item) === 7);

  const obtenerClasificacionValla = (item) => {
    if (esVallaDigital(item)) return 'Valla digital';
    if (esVallaFija(item)) return 'Valla fija';
    if (esVallaMovil(item)) return 'Valla móvil';
    return 'Valla';
  };

  const formatearAutorizacion = (valor) => (valor ? 'SI' : 'NO');

  const listadoVallas = listadoExteriores.filter((item) => esVallaDigital(item) || esVallaFija(item) || esVallaMovil(item));
  const listadoPaginasWeb = listadoExteriores.filter((item) => esPaginaWeb(item));

  return (
    <div className={classes.root}>
      <Grid container spacing={2} justifyContent="flex-start" alignItems="stretch">
        <Grid item xs={12}>
          <TituloConIcono title={"VALLAS"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
          {listadoVallas.length > 0 ? (
            listadoVallas.map((item, index) => (
              <Box key={item?.id || `${item?.tipoExterior || index}-${index}`} mb={2}>
                <ElementoDelCard title={'Clasificación:'} label={obtenerClasificacionValla(item)} />
                <ElementoDelCard title={'Tiene autorización municipal:'} label={formatearAutorizacion(item?.autorizacionMunicipal)} />
              </Box>
            ))
          ) : (
            <ElementoDelCard title={'Clasificación:'} label={'No hay vallas registradas'} />
          )}
        </Grid>
        <Grid item xs={12}>
          <TituloConIcono title={"PÁGINAS WEB"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
          {listadoPaginasWeb.length > 0 ? (
            listadoPaginasWeb.map((item, index) => {
              const enlace = item?.linkPagina || item?.sitioWeb || '';

              if (!enlace) return null;

              return (
                <Box key={item?.id || `${enlace}-${index}`} mb={2}>
                  <ElementoDelCard title={`Link ${index + 1}:`} label={enlace} />
                </Box>
              );
            })
          ) : (
            <ElementoDelCard title={'Links:'} label={'No hay páginas web registradas'} />
          )}
        </Grid>
      </Grid>
    </div>
  );
}

export default Exterior;